import React, { useState } from "react";
import PropTypes from "prop-types";
import Modal from "./ui/Modal";
import { db } from "../firebase";
import { collection, addDoc, serverTimestamp, updateDoc, doc } from "firebase/firestore";

function PollForm({ user, onFinish }) {
  const [submitting, setSubmitting] = useState(false);

  const [answers, setAnswers] = useState({
    // Sezione 1
    q1: 6,
    q2: 6,
    q3: "",
    q4: "",

    // Sezione 2
    q5: [],
    q5_other: "",
    q6: "",
    q7: "",

    // Sezione 3
    q8: 6,
    q9: 6,
    q10: "",
    q11: "",
    q12_roadTo: "No", // switch
    q15_mode: "",

    // Sezione 4 (Community) - TUTTO OBBLIGATORIO
    q16: 6, // range coinvolgimento (required)
    q13_socialFollow: "", // required (Sì/No)
    q14_merch: "", // required (Sì/No)

    // Sezione 5 (facoltative)
    age: "",
    region: "",
    province: "",
    gender: "",

    // Finale
    feedback: ""
  });

  const sectionColors = [
    "#fff8e1", // light yellow
    "#e8f5e9", // light green
    "#e3f2fd", // light blue
    "#fff3e0", // light orange
    "#f3e5f5"  // light purple
  ];

  const valueBadgeStyle = {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 40,
    height: 40,
    borderRadius: "50%",
    background: "#fff",
    color: "#111",
    fontWeight: 700,
    boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
    marginLeft: 10
  };

  const badgeButton = (label, selected) => ({
    className: `btn ${selected ? "btn-primary" : "btn-outline-secondary"} w-100`,
    "aria-pressed": selected
  });

  const toggleArray = (key, value) => {
    setAnswers((prev) => {
      const arr = new Set(prev[key] || []);
      if (arr.has(value)) arr.delete(value);
      else arr.add(value);
      return { ...prev, [key]: Array.from(arr) };
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!user?.uid) return;

    // Validazione custom (HTML5) per i required "non standard"
    const form = e.currentTarget;
    if (!form.checkValidity()) {
      form.classList.add("was-validated");
      return;
    }

    // Validazione extra: "Altre" selezionata ma senza specifica
    if ((answers.q5 || []).includes("Altre") && !answers.q5_other.trim()) {
      alert("Hai selezionato 'Altre': specifica quale federazione.");
      return;
    }

    setSubmitting(true);
    try {
      await addDoc(collection(db, "pollResponses"), {
        uid: user.uid,
        email: user.email || null,
        answers,
        createdAt: serverTimestamp()
      });

      // mark user as answered
      try {
        await updateDoc(doc(db, "users", user.uid), {
          pollAnsweredAt: serverTimestamp()
        });
      } catch (err) {
        console.warn("Impossibile aggiornare utente con pollAnsweredAt", err);
      }

      onFinish();
    } catch (err) {
      console.error("Errore inviando il sondaggio", err);
      alert("Errore durante l'invio, riprova più tardi.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="poll-form needs-validation" noValidate>
      {/* Section 1 */}
      <div className="mb-3">
        <div className="card mb-3" style={{ background: sectionColors[0] }}>
          <div className="card-body">
            <h5 className="card-title">Sezione 1 – Esperienza di gioco</h5>

            <div className="mb-3" style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label">
                <b>1.</b> Quanto ti sta piacendo il gioco del FantaWrestling fin'ora?{" "}
                <span className="text-danger">*</span>
                <span style={valueBadgeStyle}>{answers.q1}</span>
              </label>
              <input
                className="form-range"
                type="range"
                min="1"
                max="10"
                value={answers.q1}
                onChange={(e) => setAnswers((a) => ({ ...a, q1: Number(e.target.value) }))}
                required
              />
            </div>

            <div className="mb-3" style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label">
                <b>2.</b> Quanto consiglieresti ad un tuo amico di giocare al FantaWrestling?{" "}
                <span className="text-danger">*</span>
                <span style={valueBadgeStyle}>{answers.q2}</span>
              </label>
              <input
                className="form-range"
                type="range"
                min="1"
                max="10"
                value={answers.q2}
                onChange={(e) => setAnswers((a) => ({ ...a, q2: Number(e.target.value) }))}
                required
              />
            </div>

            <div className="row g-2">
              <div className="col-12 col-md-6">
                <label className="form-label">
                  <b>3.</b> Da quanto tempo giochi a FantaWrestling? <span className="text-danger">*</span>
                </label>
                <select
                  className="form-select"
                  value={answers.q3}
                  onChange={(e) => setAnswers((a) => ({ ...a, q3: e.target.value }))}
                  required
                >
                  <option value="">Seleziona...</option>
                  <option>Meno di 1 mese</option>
                  <option>1–3 mesi</option>
                  <option>3–6 mesi</option>
                  <option>Più di 6 mesi</option>
                </select>
                <div className="invalid-feedback">Seleziona una risposta.</div>
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">
                  <b>4.</b> Con che frequenza utilizzi l’app/sito FantaWrestling?
                </label>
                <select
                  className="form-select"
                  value={answers.q4}
                  onChange={(e) => setAnswers((a) => ({ ...a, q4: e.target.value }))}
                >
                  <option value="">Seleziona...</option>
                  <option>Tutti i giorni</option>
                  <option>Più volte a settimana</option>
                  <option>Una volta a settimana</option>
                  <option>Occasionalmente</option>
                  <option>Solo in occasione dei PLE/show importanti</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 2 */}
      <div className="mb-3">
        <div className="card mb-3" style={{ background: sectionColors[1] }}>
          <div className="card-body">
            <h5 className="card-title">Sezione 2 – Abitudini di visione del wrestling</h5>

            <p className="text-muted small mb-2">
              <b>5.</b> Quali federazioni segui abitualmente? <span className="text-danger">*</span>
            </p>

            {/* Hidden required: fa scattare la validazione HTML5 */}
            <input
              type="text"
              className="visually-hidden"
              tabIndex={-1}
              autoComplete="off"
              value={(answers.q5 || []).length ? "ok" : ""}
              required
              onChange={() => {}}
            />

            <div className="row g-2">
              {["WWE", "NXT", "AEW", "NJPW", "TNA", "AAA"].map((f) => {
                const sel = (answers.q5 || []).includes(f);
                return (
                  <div className="col-6 col-md-4" key={f}>
                    <button type="button" {...badgeButton(f, sel)} onClick={() => toggleArray("q5", f)}>
                      {f}
                    </button>
                  </div>
                );
              })}
            </div>

            <div className="invalid-feedback d-block mt-2">
              {(answers.q5 || []).length === 0 ? "Seleziona almeno una federazione." : ""}
            </div>

            <div className="mt-2 d-flex gap-2 align-items-center flex-wrap">
              {(() => {
                const selAlt = (answers.q5 || []).includes("Altre");
                return (
                  <>
                    <button type="button" {...badgeButton("Altre", selAlt)} onClick={() => toggleArray("q5", "Altre")}>
                      Altre
                    </button>
                    {selAlt && (
                      <input
                        className={`form-control flex-grow-1 ${selAlt && !answers.q5_other.trim() ? "is-invalid" : ""}`}
                        placeholder="Specificare"
                        value={answers.q5_other}
                        onChange={(e) => setAnswers((a) => ({ ...a, q5_other: e.target.value }))}
                      />
                    )}
                  </>
                );
              })()}
            </div>

            <div className="row mt-3">
              <div className="col-12 col-md-6 mb-2">
                <label className="form-label">
                  <b>6.</b> Qual è la federazione che segui di più?
                </label>
                <select
                  className="form-select"
                  value={answers.q6}
                  onChange={(e) => setAnswers((a) => ({ ...a, q6: e.target.value }))}
                >
                  <option value="">Seleziona...</option>
                  {(answers.q5 || []).map((opt) => (
                    <option key={opt} value={opt}>
                      {opt === "Altre" ? `Altre${answers.q5_other ? `: ${answers.q5_other}` : ""}` : opt}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label">
                  <b>7.</b> Segui gli show in diretta?
                </label>
                <select
                  className="form-select"
                  value={answers.q7}
                  onChange={(e) => setAnswers((a) => ({ ...a, q7: e.target.value }))}
                >
                  <option value="">Seleziona...</option>
                  <option>Sempre in diretta</option>
                  <option>Spesso in diretta</option>
                  <option>Raramente in diretta</option>
                  <option>Li guardo in TV (es. DMAX)</option>
                  <option>Sempre in differita</option>
                  <option>Dipende dall’evento</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Section 3 */}
      <div className="mb-3">
        <div className="card mb-3" style={{ background: sectionColors[2] }}>
          <div className="card-body">
            <h5 className="card-title">Sezione 3 – Gameplay e funzionalità</h5>

            <div className="mb-3" style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label">
                <b>8.</b> Quanto trovi chiaro il regolamento del gioco? <span className="text-danger">*</span>
                <span style={valueBadgeStyle}>{answers.q8}</span>
              </label>
              <input
                className="form-range"
                type="range"
                min="1"
                max="10"
                value={answers.q8}
                onChange={(e) => setAnswers((a) => ({ ...a, q8: Number(e.target.value) }))}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">
                <b>9.</b> Quanto trovi equilibrato il sistema di bonus e malus attuale? <span className="text-danger">*</span>
                <span style={valueBadgeStyle}>{answers.q9}</span>
              </label>
              <input
                className="form-range"
                type="range"
                min="1"
                max="10"
                value={answers.q9}
                onChange={(e) => setAnswers((a) => ({ ...a, q9: Number(e.target.value) }))}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label">
                <b>10.</b> Quali aspetti dell’app miglioreresti o implementeresti?
              </label>
              <textarea
                className="form-control"
                rows={3}
                value={answers.q10}
                onChange={(e) => setAnswers((a) => ({ ...a, q10: e.target.value }))}
              />
            </div>

            <div className="mb-3">
              <label className="form-label">
                <b>11.</b> Quali bonus o malus ti piacerebbe vedere introdotti o modificati?
              </label>
              <textarea
                className="form-control"
                rows={2}
                value={answers.q11}
                onChange={(e) => setAnswers((a) => ({ ...a, q11: e.target.value }))}
              />
            </div>

            <div className="col-12 col-md-6 mb-3">
              <label className="form-label d-block">
                <b>12.</b> Stai partecipando alla Road To WrestleMania?
              </label>
              <div className="form-check form-switch mt-1">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="q12RoadToSwitch"
                  checked={answers.q12_roadTo === "Sì"}
                  onChange={(e) => setAnswers((a) => ({ ...a, q12_roadTo: e.target.checked ? "Sì" : "No" }))}
                />
                <label className="form-check-label" htmlFor="q12RoadToSwitch">
                  {answers.q12_roadTo === "Sì" ? "Sì" : "No"}
                </label>
              </div>
            </div>

            <div>
              <label className="form-label">
                <b>13.</b> Quale modalità preferisci di più?
              </label>
              <select
                className="form-select"
                value={answers.q15_mode}
                onChange={(e) => setAnswers((a) => ({ ...a, q15_mode: e.target.value }))}
              >
                <option value="">Seleziona...</option>
                <option>Modalità indipendente</option>
                <option>Modalità competitiva</option>
                <option>Road To</option>
                <option>Le apprezzo tutte</option>
                <option>Nessuna in particolare</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Section 4 (Community) - TUTTO OBBLIGATORIO */}
      <div className="mb-3">
        <div className="card mb-3" style={{ background: sectionColors[3] }}>
          <div className="card-body">
            <h5 className="card-title">Sezione 4 – Coinvolgimento e community</h5>

            <div className="mb-3" style={{ display: "flex", flexDirection: "column" }}>
              <label className="form-label">
                <b>14.</b> Quanto ti senti coinvolto nella competizione con gli altri giocatori?{" "}
                <span className="text-danger">*</span>
                <span style={valueBadgeStyle}>{answers.q16}</span>
              </label>

              <input
                className="form-range"
                type="range"
                min="1"
                max="10"
                value={answers.q16}
                onChange={(e) => setAnswers((a) => ({ ...a, q16: Number(e.target.value) }))}
                required
              />
            </div>

            <div className="row gy-2">
              <div className="col-12 col-md-6">
                <label className="form-label d-block">
                  <b>15.</b> Segui FantaWrestling anche sui social? <span className="text-danger">*</span>
                </label>

                {/* Hidden required per validazione (switch non supporta required) */}
                <input
                  type="text"
                  className="visually-hidden"
                  tabIndex={-1}
                  value={answers.q13_socialFollow ? "ok" : ""}
                  required
                  onChange={() => {}}
                />

                <div className="form-check form-switch mt-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="q13SocialSwitch"
                    checked={answers.q13_socialFollow === "Sì"}
                    onChange={(e) => setAnswers((a) => ({ ...a, q13_socialFollow: e.target.checked ? "Sì" : "No" }))}
                    required={false}
                  />
                  <label className="form-check-label" htmlFor="q13SocialSwitch">
                    {answers.q13_socialFollow === "Sì" ? "Sì" : answers.q13_socialFollow === "No" ? "No" : "Seleziona"}
                  </label>
                </div>
                <div className="invalid-feedback d-block">
                  {!answers.q13_socialFollow ? "Rispondi a questa domanda." : ""}
                </div>
              </div>

              <div className="col-12 col-md-6">
                <label className="form-label d-block">
                  <b>16.</b> Per supportare il progetto, acquisteresti maglie o merch del FantaWrestling?{" "}
                  <span className="text-danger">*</span>
                </label>

                {/* Hidden required per validazione */}
                <input
                  type="text"
                  className="visually-hidden"
                  tabIndex={-1}
                  value={answers.q14_merch ? "ok" : ""}
                  required
                  onChange={() => {}}
                />

                <div className="form-check form-switch mt-1">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="q14MerchSwitch"
                    checked={answers.q14_merch === "Sì"}
                    onChange={(e) => setAnswers((a) => ({ ...a, q14_merch: e.target.checked ? "Sì" : "No" }))}
                    required={false}
                  />
                  <label className="form-check-label" htmlFor="q14MerchSwitch">
                    {answers.q14_merch === "Sì" ? "Sì" : answers.q14_merch === "No" ? "No" : "Seleziona"}
                  </label>
                </div>
                <div className="invalid-feedback d-block">
                  {!answers.q14_merch ? "Rispondi a questa domanda." : ""}
                </div>
              </div>
            </div>

            <div className="text-muted small mt-2">
              Nota: questa sezione è obbligatoria.
            </div>
          </div>
        </div>
      </div>

      {/* Section 5 */}
      <div className="mb-3">
        <div className="card mb-3" style={{ background: sectionColors[4] }}>
          <div className="card-body">
            <h5 className="card-title">Sezione 5 – Informazioni personali (facoltative)</h5>

            <div className="row gy-2">
              <div className="col-12 col-md-4">
                <label className="form-label">Età</label>
                <select
                  className="form-select"
                  value={answers.age}
                  onChange={(e) => setAnswers((a) => ({ ...a, age: e.target.value }))}
                >
                  <option value="">Seleziona...</option>
                  <option>Meno di 18</option>
                  <option>18–24</option>
                  <option>25–34</option>
                  <option>35–44</option>
                  <option>45+</option>
                </select>
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label">Regione</label>
                <input
                  className="form-control"
                  placeholder="Regione"
                  value={answers.region}
                  onChange={(e) => setAnswers((a) => ({ ...a, region: e.target.value }))}
                />
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label">Provincia</label>
                <input
                  className="form-control"
                  placeholder="Provincia"
                  value={answers.province}
                  onChange={(e) => setAnswers((a) => ({ ...a, province: e.target.value }))}
                />
              </div>
            </div>

            <div className="mt-3">
              <label className="form-label">Genere</label>
              <select
                className="form-select"
                value={answers.gender}
                onChange={(e) => setAnswers((a) => ({ ...a, gender: e.target.value }))}
              >
                <option value="">Seleziona...</option>
                <option>Maschio</option>
                <option>Femmina</option>
                <option>Altro</option>
                <option>Preferisco non rispondere</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Final feedback */}
      <div className="mb-3">
        <div className="card">
          <div className="card-body">
            <h5 className="card-title">Sezione finale – Feedback libero</h5>
            <label className="form-label">
              <b>17.</b> Hai suggerimenti, critiche o idee?
            </label>
            <textarea
              className="form-control"
              rows={4}
              value={answers.feedback}
              onChange={(e) => setAnswers((a) => ({ ...a, feedback: e.target.value }))}
              placeholder="Suggerimenti, critiche o idee"
            />
          </div>
        </div>
      </div>

      <div className="mt-3 d-flex justify-content-end">
        <button type="submit" className="btn btn-warning btn-lg" disabled={submitting}>
          {submitting ? "Invio..." : "Invia sondaggio"}
        </button>
      </div>
    </form>
  );
}

export default function PollModal({ user, onClose, onAnswered }) {
  const handleFinish = () => {
    if (onAnswered) onAnswered();
    if (onClose) onClose();
  };

  return (
    <Modal title="Sondaggio FantaWrestling" onClose={onClose} icon="bi-question-circle">
      <div style={{ maxHeight: "60vh", overflowY: "auto" }}>
        <p>Grazie per aiutarci a migliorare! Compila il breve questionario qui sotto.</p>
        <PollForm user={user} onFinish={handleFinish} />
      </div>
    </Modal>
  );
}

PollModal.propTypes = {
  user: PropTypes.object,
  onClose: PropTypes.func,
  onAnswered: PropTypes.func
};

export { PollForm };
